/**
 * @generated SignedSource<<be0b143787bd16704996847621816705>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedMobileRelatedItem_user$data = {
  readonly canShowSellerName: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"useFavoritesItem_user">;
  readonly " $fragmentType": "SharedMobileRelatedItem_user";
};
export type SharedMobileRelatedItem_user$key = {
  readonly " $data"?: SharedMobileRelatedItem_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedMobileRelatedItem_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedMobileRelatedItem_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFavoritesItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "cb84841e00c3f2a25ae5fd96a0ee2cb0";

export default node;
